import { render, staticRenderFns } from "./communitynetwork.vue?vue&type=template&id=ce4501ca&scoped=true"
import script from "./communitynetwork.vue?vue&type=script&lang=js"
export * from "./communitynetwork.vue?vue&type=script&lang=js"
import style0 from "./communitynetwork.vue?vue&type=style&index=0&id=ce4501ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4501ca",
  null
  
)

export default component.exports